import api from 'api'

export type IndeedFlexCompanyLocationItem = {
  ifVenueId: number
  venueName: string
  locationId: number
}

export type IndeedFlexCompanyPositionItem = {
  ifRoleId: number
  roleName: string
  positionId: number
}

export type IndeedFlexCompanyItem = {
  id: number
  ifClientId: number
  clientName: string
  companyId: number
  companyName: string
  canCreateShifts: boolean
  fileHandleId: number | null
  fileHandleName: string | null
  shiftNotificationTitle: string | null
  shiftNotificationMessage: string | null
  shiftNotificationDeliveryHour: number | null
  locations: IndeedFlexCompanyLocationItem[]
  positions: IndeedFlexCompanyPositionItem[]
}

export type ListIndeedFlexCompaniesResponse = {
  items: IndeedFlexCompanyItem[]
}

export const listIndeedFlexCompanies =
  async (): Promise<ListIndeedFlexCompaniesResponse> => {
    const response = await api.get<ListIndeedFlexCompaniesResponse>(
      '/admin/indeed_flex/companies'
    )
    return response.data
  }
